import gql from 'graphql-tag';

export const UPDATE_USER_SERVICES = gql`
  mutation updateUserService($userIds: [Int]!, $services: [ENetfrontService]!) {
    user {
      updateUserService(userIds: $userIds, services: $services)
    }
  }
`;
